var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useRef, useState, useEffect } from "react";
import { Tabs, makeStyles, Tab } from "@material-ui/core";
export default (_a) => {
    var { value, variant } = _a, props = __rest(_a, ["value", "variant"]);
    const tabIndicatorRef = useRef(null);
    const [segmentState, setSegmentState] = useState({
        width: 0,
        left: 0,
    });
    const classes = useStyles();
    useEffect(() => {
        var _a;
        if (tabIndicatorRef.current) {
            const tabsContainer = variant === "scrollable"
                ? tabIndicatorRef.current.querySelector("div.MuiTabs-scroller > .MuiTabs-flexContainer")
                : (_a = tabIndicatorRef.current.firstElementChild) === null || _a === void 0 ? void 0 : _a.firstElementChild;
            const tab = tabsContainer === null || tabsContainer === void 0 ? void 0 : tabsContainer.children[value];
            if (tab) {
                setSegmentState({
                    width: tab.clientWidth,
                    left: tab.offsetLeft,
                });
            }
        }
    }, [tabIndicatorRef, value]);
    return (React.createElement(Tabs, Object.assign({ classes: {
            root: classes.tabsRoot,
            indicator: classes.tabIndicator,
            scrollButtons: classes.scrollButtons,
            scroller: classes.scroller,
        }, variant: variant, innerRef: tabIndicatorRef, TabIndicatorProps: {
            style: {
                width: segmentState.width,
                left: segmentState.left,
                visibility: segmentState.width ? "visible" : "hidden",
            },
        }, value: value }, props)));
};
export const FTLSegmentedControl = (props) => {
    const classes = useStyles();
    return (React.createElement(Tab, Object.assign({ classes: {
            root: classes.tab,
            selected: classes.selectedTab,
            wrapper: classes.tabText,
        }, disableRipple: true }, props)));
};
const useStyles = makeStyles((theme) => ({
    tabsRoot: {
        display: "inline-flex",
        height: 32,
        minHeight: "auto",
        maxWidth: "100%",
        backgroundColor: theme.palette.segmentedControls.backgroundColor,
        padding: 4,
        boxSizing: "border-box",
        borderRadius: 4,
    },
    scroller: {
        height: 24,
    },
    scrollButtons: {
        width: 24,
        height: 24,
        color: theme.palette.icon.secondary,
        transition: "width 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
        "&.Mui-disabled": {
            width: 0,
        },
    },
    tab: {
        position: "relative",
        minWidth: 166,
        minHeight: 0,
        height: 24,
        zIndex: 2,
        opacity: 1,
        "&:not(:first-of-type):not(:last-of-type)": {
            margin: "0 2px",
        },
        "&:first-of-type": {
            marginRight: 2,
        },
        "&:last-of-type": {
            marginLeft: 2,
        },
    },
    tabText: Object.assign({ color: `${theme.palette.text.secondary} !important`, textTransform: "none" }, theme.typography.segmentControlTextPrimary),
    selectedTab: {},
    tabIndicator: {
        position: "absolute",
        zIndex: 1,
        left: 0,
        width: 0,
        height: 24,
        padding: "2px 8px",
        boxSizing: "border-box",
        borderRadius: 4,
        backgroundColor: theme.palette.segmentedControls.selected,
        transition: "left 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    },
}));
//# sourceMappingURL=FTLSegmentedControls.js.map